import { useState } from "react";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const BenefitDeleteDialog = ({ isOpen, onDismiss, onConfirm, deleting, benefit }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const onConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      const isDeleted = await onConfirm?.();
      if (isDeleted) {
        setErrorMessage("");
        onDismiss?.();
        return true;
      }

      setErrorMessage(
        "Unable to delete this benefit. Please ensure it is not in use and try again."
      );
    } catch (error) {
      setErrorMessage(
        error?.message ||
          "Unable to delete this benefit. Please ensure it is not in use and try again."
      );
    } finally {
      setIsDeleting(false);
    }

    return false;
  };

  const benefitName = benefit?.providerName || "";

  return (
    <DeleteConfirmationDialog
      isVisible={isOpen}
      onDismiss={() => {
        setErrorMessage("");
        onDismiss?.();
      }}
      onConfirm={onConfirmDelete}
      resourceName={benefitName}
      resourceType="benefit"
      confirmationValue={benefitName || "delete"}
      isDeleting={isDeleting || deleting}
      errorMessage={errorMessage}
    />
  );
};

export default BenefitDeleteDialog;